import { createContext } from "react";
export const OwnerGuideContext = createContext(null);
